var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 34,
    viewBox: "0 0 104 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6433 17.5195L86.6205 22.4241H96.2474V24.4773H83.8374V8.50854H96.1789V10.5617H86.6433V15.4663H96.1789V17.5195H86.6433Z",
    fill: "#5E5E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7902 22.3101L82.7673 24.4773H75.1936V8.50854H78.1364L77.9995 22.3101H82.7902Z",
    fill: "#5E5E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6326 15.9226C71.4576 15.9226 74.1723 16.721 74.1723 20.006C74.1723 23.1313 71.6857 24.5001 68.7885 24.4773H63.7698V8.50855H68.3779C71.2751 8.32605 73.8073 9.44386 73.8073 12.341C73.8073 15.147 71.4576 15.877 69.6326 15.877V15.9226ZM66.5757 14.896H68.3779C69.9063 14.896 71.0013 14.2117 71.0013 12.592C71.0013 11.0864 69.9063 10.5389 68.3779 10.5617H66.5757V14.896ZM66.5757 22.4241H68.8113C70.4082 22.447 71.3663 21.4204 71.3663 19.6638C71.3663 17.9301 69.9063 16.9263 68.3779 16.9492H66.5757V22.4241Z",
    fill: "#5E5E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0035 15.9226C59.8285 15.9226 62.5432 16.721 62.5432 20.006C62.5432 23.1313 60.0567 24.5001 57.1595 24.4773H52.1407V8.50855H56.7489C59.646 8.32605 62.1782 9.44386 62.1782 12.341C62.1782 15.147 59.8285 15.877 58.0035 15.877V15.9226ZM54.9467 14.896H56.7489C58.2773 14.896 59.3723 14.2117 59.3723 12.592C59.3723 11.0864 58.2773 10.5389 56.7489 10.5617H54.9467V14.896ZM54.9467 22.4241H57.1823C58.7792 22.447 59.7373 21.4204 59.7373 19.6638C59.7373 17.9301 58.2773 16.9263 56.7489 16.9492H54.9467V22.4241Z",
    fill: "#5E5E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4123 8.50854L50.4351 24.4773H47.6063V8.50854H50.4123Z",
    fill: "#5E5E6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7014 8.50854V16.4245L43.1042 8.50854H45.9102L41.6214 16.2192H46.1383L42.2146 24.4773H39.4086L42.6708 17.9985H38.7243V24.4773H35.8955V8.50854H38.7014Z",
    fill: "#5E5E6B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.3748,
    y: 20.663,
    width: 4.15092,
    height: 4.15092,
    rx: 1.20758,
    fill: "#5E5E6B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1405 8.1532H12.745C12.319 8.1532 11.9314 8.39937 11.7503 8.78492L4.95714 23.2479C4.61484 23.9766 5.14663 24.814 5.95179 24.814H10.4203C10.848 24.814 11.2367 24.5659 11.4169 24.1781L18.1371 9.71516C18.4755 8.98676 17.9437 8.1532 17.1405 8.1532Z",
    fill: "#5E5E6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2971 8.1532H30.6495C31.4518 8.1532 31.9836 8.98502 31.6469 9.71324L28.7923 15.8879C28.6126 16.2767 28.2232 16.5256 27.7949 16.5256H21.7238L24.9394 23.2404C25.2887 23.9698 24.7571 24.814 23.9483 24.814H19.561C19.1349 24.814 18.7473 24.5677 18.5662 24.182L15.7076 18.0914C15.3655 17.3627 15.8973 16.5256 16.7023 16.5256H21.7238L25.2996 8.79096C25.4794 8.40213 25.8687 8.1532 26.2971 8.1532Z",
    fill: "#5E5E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.6b1bb6c61b8cdf7261d2b16e4aeec43f.svg";
export { ForwardRef as ReactComponent };